<app-oee-modal
    title="Abort Job"
    [contextName]="data.equipmentName"
    subtitle="This action cannot be undone. Select a reason for aborting this job."
    icon="fa-ban"
    iconColor="red"
    tint="red"
    size="md">

    <ng-container modal-content>
        <!-- Job Info Card -->
        <div class="batch-info-card">
            <div class="info-row">
                <mat-icon class="info-icon">inventory_2</mat-icon>
                <div class="info-content">
                    <span class="info-label">Job:</span>
                    <span class="info-value">{{ data.batch.batch_number || 'Unnamed Job' }}</span>
                </div>
            </div>
            <div class="info-row">
                <mat-icon class="info-icon">precision_manufacturing</mat-icon>
                <div class="info-content">
                    <span class="info-label">Equipment:</span>
                    <span class="info-value">{{ data.equipmentName }}</span>
                </div>
            </div>
            @if (data.batch.product_name) {
                <div class="info-row">
                    <mat-icon class="info-icon">inventory_2</mat-icon>
                    <div class="info-content">
                        <span class="info-label">Product:</span>
                        <span class="info-value">{{ data.batch.product_name }}@if (data.batch.product_code) { ({{ data.batch.product_code }})}</span>
                    </div>
                </div>
            }
            <div class="info-row warning-row">
                <mat-icon class="info-icon">warning</mat-icon>
                <div class="info-content">
                    <span class="info-label">OEE Impact</span>
                    <span class="info-value">Included in Availability/Performance, excluded from Quality</span>
                </div>
            </div>
        </div>

        <!-- Reason Selection -->
        <div class="reason-section">
            <label class="form-label fw-bold">
                Why is this job being aborted? <span class="text-danger">*</span>
            </label>

            <!-- Loading state -->
            @if (loadingReasons) {
                <div class="text-center py-3">
                    <mat-spinner diameter="24" class="mx-auto"></mat-spinner>
                    <span class="d-block mt-2 text-muted">Loading abort reasons...</span>
                </div>
            } @else if (abortReasonGroups.length === 0) {
                <!-- No reasons configured -->
                <div class="alert alert-info">
                    <mat-icon class="me-2">info</mat-icon>
                    No abort reasons have been configured for this site.
                    Please configure abort reasons in the site settings.
                </div>
            } @else {
                <!-- Reason groups -->
                @for (group of abortReasonGroups; track group.name) {
                    <div class="reason-group mb-3">
                        <div class="reason-group-header">{{ group.name }}</div>
                        <div class="reason-options">
                            @for (reason of group.reasons; track reason.id) {
                                <button
                                    type="button"
                                    class="reason-chip"
                                    [class.selected]="isReasonSelected(reason)"
                                    [class.inactive]="!reason.is_active"
                                    [disabled]="!reason.is_active"
                                    (click)="selectReason(reason)"
                                    [title]="reason.description || reason.name">
                                    <span class="reason-code">{{ reason.code }}</span>
                                    <span class="reason-name">{{ reason.name }}</span>
                                </button>
                            }
                        </div>
                    </div>
                }
            }

            <!-- Selected reason details -->
            @if (selectedReason) {
                <div class="selected-reason-info mt-3">
                    <div class="d-flex align-items-center">
                        <mat-icon class="text-success me-2">check_circle</mat-icon>
                        <strong>{{ selectedReason.code }}: {{ selectedReason.name }}</strong>
                    </div>
                    @if (selectedReason.description) {
                        <p class="text-muted mb-0 mt-1 ms-4">
                            {{ selectedReason.description }}
                        </p>
                    }
                </div>
            }
        </div>
    </ng-container>

    <ng-container modal-actions>
        <app-detail-action-bar
            flavor="material"
            [actions]="footerActions"
            (action)="onFooterAction($event)">
        </app-detail-action-bar>
    </ng-container>
</app-oee-modal>
